// @ts-nocheck
import { Themes } from './shared/types/Personalization';
import { IQueryParams } from './shared/services/api.service';

export interface IConfig extends IQueryParams {
  tintSlug: string;
  columns?: number;
  clickForMore?: boolean;
  infiniteScroll?: boolean;
  paginate?: boolean;
  noButtons?: boolean;
  noImages?: boolean;
  slideShowCtrl?: boolean;
  noPopup?: boolean;
  noImagesScaling?: boolean;
  mobileScroll?: boolean;
  noMobileRender?: boolean;
  noMobileNavmenu?: boolean;
  noCache?: boolean;
  count?: number;
  query?: string;
  personalizationId?: number;
  noTrack?: boolean;
  touchScreen?: boolean;
  cta_append?: string;
  utmPassthrough?: string;
  utm_campaign?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_content?: string;
  utm_term?: string;
  network?: string;
  width?: number;
  personalization_id?: number;
  fullscreen?: boolean;
  tags?: string;
  theme?: Themes;
  expand?: boolean;
  saved_filter_id?: number;
  'saved-filter-id'?: number;
  outerFrame?: boolean;
  from?: number;
  product_sku?: string;
  hideNoContent?: boolean;
  postTags?: string;
  formValues?: string;
  title?: string;
  addPostOpen?: boolean;
  hidePopup?: boolean;
  innerIFrame?: boolean;
  draftPersonalization?: boolean;
}

export const getConfig = (): IConfig => {
  // Move to global method
  const tintup = document.querySelector('.tintup');
  const rootNode = tintup?.shadowRoot.getElementById('tintup');

  const rootURL = rootNode ? new URL(rootNode.getAttribute('data-url')) : null;
  const hashURL = rootURL ? rootURL.hash : window.location.hash;
  const hrefURL = rootURL ? rootURL.href : location.href;

  const url = hashURL ? hashURL : hrefURL;
  const parsedUrl = url.match(new RegExp('([^?=&]+)(=([^&]*))?', 'g'));
  const finalURL = parsedUrl ? parsedUrl : [];

  return finalURL.reduce(
    (result: IConfig, each) => {
      const [key, value] = each.split('=');

      if (value) {
        result[key] =
          value === 'true' || value === 'false'
            ? value === 'true'
            : !isNaN(Number(value))
            ? parseInt(value, 10)
            : value;

        if (key === 'formValues') {
          result[key] = decodeURIComponent(value);
        }

        key === 'notrack' ? (result.noTrack = result[key]) : null;
        key === 'personalization_id' ? (result.personalizationId = result[key]) : null;
        (key === 'personalizationId' || key === 'personalization_id') && value === 'undefined'
          ? delete result.personalizationId
          : null;
        return result;
      } else {
        try {
          if (key.includes('#')) {
            const toSplit = '#';
            return getResultFromKey(toSplit, key, result);
          } else if (key.includes('/t/')) {
            const toSplit = '/t/';
            return getResultFromKey(toSplit, key, result);
          }
          return result;
        } catch (e) {
          return result;
        }
      }
    },
    { tintSlug: '' }
  );
};

const getResultFromKey = (splitChar: string, key: string, result: IConfig) => {
  const [_, tintSlug] = key.split(splitChar);

  if (tintSlug.includes('/')) {
    const [slug, network] = tintSlug.split('/');
    result.tintSlug = slug;
    result.network = network;
    return result;
  }

  result.tintSlug = tintSlug;
  return result;
};
